import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels, EditorControls } from '../../BaseEditor';
import TPs from './tp';

const editorRenderer = (getControl, {
  data,
  dataSetter,
  fields,
}) => (
  <Grid container spacing={2}>
    <Grid item sm={2}>
      {getControl('code')}
    </Grid>
    <Grid item sm={10}>
      {getControl('name')}
    </Grid>
    <Grid item xl={3} lg={4} md={5} sm={12}>
      {getControl('not_import412')}
      {getControl('state_tax')}
      {getControl('local_tax')}
    </Grid>
    <Grid item xl={9} lg={8} md={7} sm={12}>
      <EditorControls.ItemPicker
        label="Батьківський елемент"
        backend="/api/catalog/kdbs/"
        canErase
        value={data.parent}
        onChange={(e, v) => dataSetter({ parent: v })}
        mode="no-repr"
      />
    </Grid>
    <Grid item xs={12}>
      <TPs.GeneralTP
        data={data.ratiokdbhistory_set}
        options={fields.ratiokdbhistory_set}
        onChange={(e, newRecs) => dataSetter({ ratiokdbhistory_set: newRecs })}
      />
    </Grid>

  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/kdbs/', CommandPanels.catCommandPanel);
